import { TEndpoint, TUserType } from 'contexts/app-context/types'
import { OutgoingHttpHeaders } from 'http2'
import { AxiosRequestConfig } from 'axios'
import { IRequestReportRequest, Metadados, Metadata, PostReportRequest } from 'common/types'
import {
  TSendReportRequest,
  TTicketFile,
  TTicketFileWithS3Uri,
  TUploadUrlRequest,
} from 'pages/new-service/types/NewService.types'
import { IRequestTermsRequest, IRequestTermsResponse } from 'pages'
import { ITermsPendingAcceptanceRequest } from 'pages/privacy-policy-acceptance/types'

import { TraceDataProps } from './services/trace'
import { makeBridgeRequest, makeHttpRequest } from './helpers'

// Grouped types due to SonarQube
type TMetadataPayload<UserType extends TUserType> = Metadados<UserType> | Metadata
type TReportPayload = PostReportRequest | IRequestReportRequest
type TDataBody =
  | TMetadataPayload<TUserType>
  | TReportPayload
  | TTicketFile[]
  | TTicketFileWithS3Uri[]
  | TUploadUrlRequest
  | TSendReportRequest
  | IRequestTermsRequest
  | IRequestTermsResponse
  | ITermsPendingAcceptanceRequest
  | Record<string, unknown>
export default interface Data {
  action: string
  evtId: string
  metadata: {
    body?: TDataBody
    endpoint: string
    headers?: OutgoingHttpHeaders
    method: string
    engine: string
  }
}

const baseRequestData = (endpoint: TEndpoint, body: Data['metadata']['body']): Data => {
  const formattedBody = endpoint.method.toUpperCase() === 'GET' ? undefined : body
  return {
    action: 'requestAPI',
    evtId: endpoint.id,
    metadata: {
      method: endpoint.method,
      endpoint: endpoint.url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...endpoint.headers,
      },
      body: formattedBody,
      engine: 'CA',
    },
  }
}

export type BridgeRequestParams = {
  endpoint: TEndpoint
  body?: Data['metadata']['body']
  returnAllResponse?: boolean
  isUSBranch?: boolean
}

const bridgeRequest = async <T>({
  endpoint,
  body = {},
  returnAllResponse = false,
  isUSBranch,
}: BridgeRequestParams): Promise<T> =>
  makeBridgeRequest(baseRequestData(endpoint, body), undefined, returnAllResponse, isUSBranch).then(
    (response) => response,
  )

const httpRequest = async <T>(
  axiosConfig: AxiosRequestConfig,
  context?: TraceDataProps['context'],
) => makeHttpRequest<T>(axiosConfig, context).then((response) => response)

export { bridgeRequest, httpRequest }
